import React, { useEffect } from 'react';
import { useAlert } from 'glints-aries/es/@next';
import { useIntl } from 'react-intl';
import { StringParam, useQueryParam } from 'use-query-params';

import { COMPANY_CREATED_ALERT } from '../../modules/CompanyDashboard/shared/constants';

export const useShowCreateCompanySuccess = () => {
  const intl = useIntl();
  const { formatMessage } = intl;

  const { open } = useAlert();

  const [createCompanySuccess, setCreateCompanySuccess] = useQueryParam(
    'createCompanySuccess',
    StringParam
  );

  useEffect(() => {
    if (createCompanySuccess) {
      setCreateCompanySuccess(undefined);

      open({
        title: formatMessage(COMPANY_CREATED_ALERT.title),
        content: formatMessage(COMPANY_CREATED_ALERT.content, {
          br: <br />,
        }),
        status: 'success',
      });
    }
  }, [createCompanySuccess, setCreateCompanySuccess, formatMessage, open]);
};
